import React, { useState } from "react";
import AxiosInstance from "../axios/AxiosInstance"; // Assurez-vous que votre AxiosInstance est importé correctement
import { message } from "antd"; // Si vous utilisez Ant Design pour les messages d'erreur

export default function SwitcherAgencePage() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Gère l'affichage du menu déroulant
  const [selectedAgency, setSelectedAgency] = useState(null); // Agence sélectionnée

  // Fonction pour ouvrir/fermer le menu déroulant
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Fonction pour changer d'agence
  const switchAgency = (agencyName, agencyId) => {
    AxiosInstance.post("agency/switch", { agency: agencyId })
      .then((res) => {
        setSelectedAgency(agencyName); // Mettre à jour l'agence sélectionnée
        setIsDropdownOpen(false); // Fermer le menu déroulant après avoir sélectionné une agence
        console.log(res);
      })
      .catch((e) => {
        if (e.response.data.statusCode === 403) {
          message.error("Vous n'êtes pas autorisé à changer d'agence !");
        }
      });
  };

  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      <h1 style={{ fontSize: "24px", marginBottom: "20px", color: "#333" }}>
        Switcher Agence
      </h1>
      <p style={{ fontSize: "16px", color: "#555" }}>
        La fonctionnalité pour changer d'agence sera bientôt disponible ici.
      </p>

      {/* Bouton pour ouvrir/fermer le menu déroulant */}
      <button
        onClick={toggleDropdown}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        {selectedAgency ? selectedAgency : "Switcher Agence"}
      </button>

      {/* Menu déroulant avec les agences */}
      {isDropdownOpen && (
        <div
          style={{
            position: "absolute",
            top: "60px", // Positionner juste en dessous du bouton
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "5px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            width: "200px",
            zIndex: 10,
            padding: "10px",
            textAlign: "center",
          }}
        >
          <p
            onClick={() => switchAgency("Asnieres", "650adee7951dd697c7535e3e")}
            style={{
              padding: "8px",
              cursor: "pointer",
              margin: "5px 0",
              backgroundColor: "#f0f0f0",
              borderRadius: "3px",
              transition: "background-color 0.2s",
            }}
            className="hover:cursor-pointer"
          >
            Asnieres sur Seine
          </p>
          <p
            onClick={() => switchAgency("Brive", "6533fe25099978decf532a59")}
            style={{
              padding: "8px",
              cursor: "pointer",
              margin: "5px 0",
              backgroundColor: "#f0f0f0",
              borderRadius: "3px",
              transition: "background-color 0.2s",
            }}
            className="hover:cursor-pointer"
          >
            Brive
          </p>
          <p
            onClick={() => switchAgency("Toulouse", "654a3d82874a059df3f98653")}
            style={{
              padding: "8px",
              cursor: "pointer",
              margin: "5px 0",
              backgroundColor: "#f0f0f0",
              borderRadius: "3px",
              transition: "background-color 0.2s",
            }}
            className="hover:cursor-pointer"
          >
            Toulouse
          </p>
        </div>
      )}
    </div>
  );
}
